import * as classNames from 'classnames';
import * as React from 'react';
import { IconName } from '@ReactConstants/iconNames';
import * as style from './Icon.styl';
import '../../../../public/styles/abacons.styl';

interface IIconProps {
  tooltipText?: string;
  tooltipDirection?: 'top' | 'left' | 'right' | 'bottom';
  type?: 'primary' | 'secondary';
  small?: boolean;
  large?: boolean;
  name: IconName;
  customClasses?: string[];
}

export class Icon extends React.Component<IIconProps> {
  constructor(props: IIconProps) {
    super(props);
  }

  getTooltipProps = () => {
    const { tooltipText, tooltipDirection } = this.props;
    const tooltipProps: any = {};

    if (tooltipText) {
      tooltipProps['data-rh'] = tooltipText;
    }

    if (tooltipDirection) {
      tooltipProps['data-rh-at'] = tooltipDirection;
    }

    return tooltipProps;
  };

  render() {
    const { small, large, type } = this.props;
    const cssClasses = classNames(
      style.global,
      'icon',
      'icon-' + this.props.name,
      { small, large, [`icon-${type}`]: Boolean(type) },
      classNames(this.props.customClasses)
    );

    return <span className={cssClasses} {...this.getTooltipProps()} />;
  }
}
